module.exports = __webpack_public_path__ + "media/images/value-a409fb12028488c1e855460dc77c084a.png";